// @flow
import React from 'react'
import { Field, reduxForm } from 'redux-form'
import FormButtons from 'components/FormButtons'
import { renderFileUpload, renderInputField } from 'components/FormFields'
import normalizers from 'lib/field/normalizers'
import validators from 'lib/field/validators'
import { httpPost } from 'lib/http'
import { setBanner, setLoad, setUnload } from 'lib/notification/actions'
import { unsetModal } from 'lib/modal/actions'
import type { Form } from 'lib/types'
import styles from './styles'

type Props = {
  number: number,
  subnumber: number,
  form: Form,
  onSuccess: Function,
}

const onSubmit = (number, subnumber, onSuccess, { file, name }, dispatch) => {
  const data = {
    'content-type': file.content_type,
    data: file.data,
    name: name,
  }
  dispatch(setLoad())
  const url = `/admin/accounts/${number}/subaccounts/${subnumber}/attachments`
  return httpPost(url, data)
    .then(() => {
      dispatch(onSuccess)
      dispatch(setBanner('Document successfully attached'))
    })
    .catch(() => {
      dispatch(setBanner('File attachment failed', 'danger'))
    })
    .then(() => {
      dispatch(unsetModal())
      dispatch(setUnload())
    })
}

const Component = ({ number, subnumber, onSuccess, form }: Props) => {
  const handleSubmit = form.handleSubmit((data, dispatch) => {
    return onSubmit(number, subnumber, onSuccess, data, dispatch)
  })
  return (
    <section>
      <h4 className="section">Attach Document</h4>
      <form onSubmit={handleSubmit}>
        <div className="section">
          <div className={styles.formItemHalf}>
            <Field
              cleaner={(val) => val && val.trim()}
              component={renderInputField}
              label="Name"
              name="name"
              type="text"
              validate={validators.requiredWithTrim}
              autoFocus
            />
          </div>
          <div className={styles.formItemHalf}>
            <Field
              component={renderFileUpload}
              label="File"
              name="file"
              normalize={normalizers.file}
              validate={validators.requiredField}
            />
          </div>
        </div>
        <FormButtons {...form} />
      </form>
    </section>
  )
}

export default reduxForm({
  form: 'attachment',
  propNamespace: 'form',
})(Component)
